import React, { useEffect, useState } from "react";
import { HeaderLeftContent, StyledHeader } from "../../Common/styles/header";
import { Box, Chip, CircularProgress, Stack, Typography } from "@mui/material";
import { errorToastMessage } from "../../../utils/toast";
import { AxiosResponse } from "axios";
import http from "../../../utils/http";
import { useNavigate } from "react-router-dom";

const statusLabelMap: any = {
  pending: "Pending",
  not_started: "Not started",
  completed: "Completed",
};

const statusTextColorMap: any = {
  pending: "#723B13",
  not_started: "#111928",
  completed: "#03543F",
};

const statusBgColorMap: any = {
  pending: "#FDF6B2",
  not_started: "#00000014",
  completed: "#DEF7EC",
};

const SurveyPackage = () => {
  const [loading, setLoading] = useState(true);

  const [surveyPackages, setSurveyPackages] = useState([]);

  const studyId = localStorage.getItem("study-id") || "";
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res: AxiosResponse = await http.get(
          `/participant-survey/list?studyId=${studyId}`
        );
        const formattedData = res.data?.data?.map((item: any) => ({
          id: item?.id,
          surveyPackageId: item?.package?.id,
          name: item?.package?.name || "",
          status:
            item?.status === "sent"
              ? item?.totalForms > 0
                ? "pending"
                : "not_started"
              : item?.status,
        }));
        setSurveyPackages(formattedData || []);
        setLoading(false);
      } catch (err) {
        errorToastMessage(err as Error);
        setLoading(false);
      }
    };
    fetchData();
  }, [setLoading, studyId]);

  const navigateToSurvey = (surveyId: string) => {
    navigate(`/participant/questionnaires/${studyId}/survey/${surveyId}`);
  };

  return (
    <>
      <StyledHeader sx={{ borderBottom: "1px solid #e0e3eb" }}>
        <Box sx={HeaderLeftContent}>
          <Typography fontSize={20} fontWeight={600} color="text.primary">
            Questionnaires
          </Typography>
        </Box>
      </StyledHeader>
      {!loading ? (
        <Box
          sx={{
            p: 3,
            height: "calc(100% - 80px)",
            overflowY: "auto",
          }}
        >
          {surveyPackages.length > 0 ? (
            <Box
              sx={{
                // height: "100%",
                display: "flex",
                gap: 2,
                alignItems: "flex-start",
                flexWrap: "wrap",
              }}
            >
              {surveyPackages?.map((item: any) => (
                <Stack
                  key={item.id}
                  gap={2}
                  sx={{
                    p: 2,
                    borderRadius: "12px",
                    boxShadow: "0px 0px 12px 0px #00000014",
                    bgcolor: "#fff",
                    minHeight: "125px",
                    width: {
                      xs: "100%",
                      lg: "calc(50% - 8px)",
                    },
                  }}
                >
                  <Typography variant="subtitle2" fontWeight="medium">
                    {item?.name || "-"}
                  </Typography>
                  <Box
                    sx={{
                      mt: "auto",
                      display: "flex",
                      gap: 2,
                      justifyContent: "space-between",
                      alignItems: "center",
                      flexWrap: "wrap",
                    }}
                  >
                    <Chip
                      label={statusLabelMap[item?.status] || ""}
                      sx={{
                        borderRadius: "8px",
                        px: "10px",
                        textTransform: "capitalize",
                        fontSize: 12,
                        fontWeight: 600,
                        color: statusTextColorMap[item?.status],
                        bgcolor: statusBgColorMap[item?.status],
                      }}
                    />

                    {/* <Button
                      variant="text"
                      onClick={() => navigateToSurvey(item.id)}
                    >
                      
                    </Button> */}
                    <Typography
                      variant="subtitle1"
                      fontWeight="medium"
                      color="primary"
                      sx={{ cursor: "pointer" }}
                      onClick={() => navigateToSurvey(item.id)}
                    >
                      Start Questionnaire
                    </Typography>
                  </Box>
                </Stack>
              ))}
            </Box>
          ) : (
            <Box
              sx={{
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexGrow: 1,
              }}
            >
              <Typography variant="body1" color="gray">
                No Questionnaires Found
              </Typography>
            </Box>
          )}
        </Box>
      ) : (
        <Box
          sx={{
            height: "calc(100% - 80px)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress />
        </Box>
      )}
    </>
  );
};

export default SurveyPackage;
